var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTillitLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "40px",
    viewBox: "0 0 91 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prototype-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tillit---homepage",
    transform: "translate(-60.000000, -142.000000)",
    fill: "#1E1E85"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigatie",
    transform: "translate(0.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(59.999878, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.139435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4313736,39.8605537 C7.6902914,39.8605537 5.09378433,37.2236462 5.09378433,30.5292816 L5.09378433,18.9668503 L0,18.9668503 L0,10.9542542 L5.24306393,10.9542542 L5.24306393,3.75248623 L13.53265,0 L13.53265,10.9542542 L19.924469,10.9542542 L19.924469,18.9668503 L13.53265,18.9668503 L13.53265,28.8053036 C13.53265,31.2391157 14.6311377,32.2033157 16.379406,32.2033157 C17.6271743,32.2033157 18.7263155,31.8992257 19.924469,31.1381207 L19.924469,38.8468513 C18.2765183,39.4041994 16.1796418,39.8605537 14.4313736,39.8605537 Z",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.8501225,39.0909061 L31.8501225,10.9090881 L22.7501221,10.9090881 L22.7501221,39.0909061 L31.8501225,39.0909061 Z",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6800785,39.0909081 L43.6800785,0 L34.5800781,0 L34.5800781,39.0909081 L43.6800785,39.0909081 Z",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4200687,39.0909081 L56.4200687,0 L47.3200684,0 L47.3200684,39.0909081 L56.4200687,39.0909081 Z",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2501469,39.0909061 L68.2501469,10.9090881 L59.1501465,10.9090881 L59.1501465,39.0909061 L68.2501469,39.0909061 Z",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.480669,40 C78.7072659,40 76.0983095,37.3538694 76.0983095,30.6360855 L76.0983095,19.033205 L70.9801025,19.033205 L70.9801025,10.9925766 L76.2483048,10.9925766 L76.2483048,3.76561379 L84.5776358,0 L84.5776358,10.9925766 L91.000103,10.9925766 L91.000103,19.033205 L84.5776358,19.033205 L84.5776358,28.9060764 C84.5776358,31.348403 85.6813911,32.3159752 87.4380417,32.3159752 C88.6917925,32.3159752 89.7962048,32.0108227 91.000103,31.2470551 L91.000103,38.9827538 C89.344251,39.5420516 87.2373196,40 85.480669,40 Z",
    id: "Fill-9"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTillitLogoBlue);
export default __webpack_public_path__ + "static/media/tillit_logo_blue.c3649b0f2e10f0e5e9b75087b6c0f781.svg";
export { ForwardRef as ReactComponent };